// extracted by mini-css-extract-plugin
module.exports = {"container":"e_zx","fullWidth":"e_Ax"};